var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8577 2L5.00181 7.97735C5.00066 7.98537 5.0001 7.99294 5.00001 8H13C12.9999 7.99294 12.9993 7.98537 12.9982 7.97735L12.1423 2H5.8577ZM5.71849 1C5.29851 1 4.94008 1.35341 4.87104 1.8356L4.0119 7.8356C3.92462 8.44513 4.32846 9 4.85935 9H13.1406C13.6715 9 14.0754 8.44513 13.9881 7.8356L13.129 1.8356C13.0599 1.35341 12.7015 1 12.2815 1H5.71849Z",
    fill: "#CFD8E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4947 11H4.50533C4.49916 11 4.49461 11.0016 4.49145 11.0036C4.48994 11.0045 4.48919 11.0052 4.48888 11.0056L4.00362 11.9983C4.00382 11.9984 4.00397 11.9985 4.00406 11.9986L4.00509 11.9989C4.00578 11.9991 4.00922 12 4.0165 12H13.9835C13.9908 12 13.9942 11.9991 13.9949 11.9989L13.9959 11.9986C13.996 11.9985 13.9962 11.9984 13.9964 11.9983L13.5111 11.0056C13.5108 11.0052 13.5101 11.0045 13.5086 11.0036C13.5054 11.0016 13.5008 11 13.4947 11ZM4.50533 10C4.11532 10 3.75978 10.2201 3.59059 10.5662L3.10176 11.5662C2.77722 12.2301 3.26839 13 4.0165 13H13.9835C14.7316 13 15.2228 12.2301 14.8982 11.5662L14.4094 10.5662C14.2402 10.2201 13.8847 10 13.4947 10H4.50533Z",
    fill: "#CFD8E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 16C4.22386 16 4 16.2239 4 16.5C4 16.7761 3.77614 17 3.5 17C3.22386 17 3 16.7761 3 16.5C3 15.6716 3.67157 15 4.5 15H13.5C14.3284 15 15 15.6716 15 16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5C14 16.2239 13.7761 16 13.5 16H4.5Z",
    fill: "#CFD8E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13H9.5V15H8.5V13Z",
    fill: "#CFD8E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.cd1c2a518a50c0691be770c75ad82a14.svg";
export { ForwardRef as ReactComponent };